exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-leaderboard-tsx": () => import("./../../../src/pages/leaderboard.tsx" /* webpackChunkName: "component---src-pages-leaderboard-tsx" */),
  "component---src-pages-schedule-tsx": () => import("./../../../src/pages/schedule.tsx" /* webpackChunkName: "component---src-pages-schedule-tsx" */),
  "component---src-templates-legal-legal-tsx": () => import("./../../../src/templates/legal/legal.tsx" /* webpackChunkName: "component---src-templates-legal-legal-tsx" */)
}

